<template>
  <div>
    <el-form @submit.native.prevent="editTvideo" :inline="true">
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" multiple placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select v-model="model.clID" multiple placeholder="三级分类">
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-card>
        <div>
          <h3>修改试听目录</h3>
          <el-form-item label="目录对应课程名称">
            <el-input v-model="model.tvName"></el-input>
          </el-form-item>
          <el-form-item label="tvID(自动生成)">
            <el-input :disabled="true" v-model="model.tvID"></el-input>
          </el-form-item>
          <div
            v-for="(item, index) in tvideos"
            :key="item.tvideoId"
            style="display: flex"
          >
            <el-form-item label="目录ID">
              <el-input v-model="item.tvideoId"></el-input>
            </el-form-item>
            <el-form-item label="目录名称">
              <el-input v-model="item.tvideoName"></el-input>
            </el-form-item>
            <el-form-item label="目录链接">
              <el-input v-model="item.tvideoVid"></el-input>
            </el-form-item>
            <el-form-item label="目录时长">
              <el-input v-model="item.tvideoTime"></el-input>
            </el-form-item>
            <el-button
              @click="delTvideoInput(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>
          <el-button @click="addTvideoInput">新增一行</el-button>
        </div>
      </el-card>
      <el-form-item style="margin-top: 25px">
        <el-button type="primary" native-type="submit">点击修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      model: {
        tvName: "",
        tvID: "",
      },
      tvName: "",
      tvID: "",
      tvideos: [
        {
          tvideoId: Date.now(),
          tvideoName: "",
          tvideoVid: "",
          tvideoTime: "",
        },
      ],
    };
  },
  methods: {
    async editTvideo() {
      try {
        const params = {
          tvideos: this.tvideos,
          tvName: this.model.tvName,
          tvID: this.model.tvID,
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        const result = await this.$http.put(
          "/tvideo/puttvideo?_id=" + `${this.id}`,
          params
        );
        if (result.status == 200) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.$router.push("/tvideo/list");
        }
      } catch (error) {
        this.$message({
          type: "danger",
          message: error.message,
        });
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        //console.log(item);
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    //获取需要编辑的目录
    async getEditTvideo() {
      try {
        const result = await this.$http.get("/tvideo/getedit", {
          params: { id: this.id },
        });
        this.tvideos = result.data.tvideos;
        this.model.maID = result.data.maID;
        this.model.chID = result.data.chID;
        this.model.coID = result.data.coID;
        this.model.clID = result.data.clID;
        this.model.tvName = result.data.tvName;
        this.model.tvID = result.data.tvID;
      } catch (error) {
        console.log(error);
      }
    },

    // 动态添加
    addTvideoInput(index) {
      try {
        this.tvideos.push({
          tvideoId: Date.now(),
          tvideoName: "",
          tvideoVid: "",
          tvideoTime: "",
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除
    delTvideoInput(index) {
      try {
        this.tvideos.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    //生成试听名称tvID
    /* createTvID() {
      this.tvID = Date.now();
    }, */
  },
  created() {
    this.getMajor();
    this.getChannel();

    this.id && this.getEditTvideo(this.id);
  },
};
</script>
